import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import UIKit from 'uikit'
import UIkitIcons from 'uikit/dist/js/uikit-icons'
import * as VueCookie from 'vue-cookie'
import * as VeeValidate from 'vee-validate'
import VueCryptojs from 'vue-cryptojs'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTrash,
  faPencilAlt,
  faFileDownload,
  faBlog,
  faSpinner,
  faDownload,
  faPlus,
  faStar,
  faMicrophone,
  faLaugh,
  faPaperclip,
  faPaperPlane,
  faPlay,
  faPause,
  faArrowLeft,
  faShareAlt,
  faCheck,
  faTimes,
  faHashtag,
  faClock,
  faTriangleExclamation,
  faFolderPlus,
  faBan,
  faFilePdf,
  faEnvelope,
  faLink,
  faFileCirclePlus,
  faChevronDown,
  faRotateLeft,
  faRotateRight
} from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebook, faFacebookF, faTwitter, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import Vuetify, { VDataTable, VTabs, VTab, VTabsItems, VTabItem } from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

import VueSocialSharing from 'vue-social-sharing'

import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import './tailwind.css'

(UIKit as any).use(UIkitIcons)

Vue.use(VueCookie)
Vue.use(VueCryptojs)
Vue.use(VeeValidate)
Vue.use(Vuetify, {
  components: { VDataTable, VTabs, VTab, VTabsItems, VTabItem }
})

Vue.use(VueSocialSharing)

library.add(faTrash)
library.add(faPencilAlt)
library.add(faBlog)
library.add(faPlus)
library.add(faStar)
library.add(faLaugh)
library.add(faPaperclip)
library.add(faPaperPlane)
library.add(faPlay)
library.add(faPause)
library.add(faShareAlt)
library.add(faCheck)
library.add(faTimes)
library.add(faHashtag)
library.add(faArrowLeft)
library.add(faSpinner)
library.add(faDownload)
library.add(faMicrophone)
library.add(faClock)
library.add(faFolderPlus)
library.add(faBan)
library.add(faFilePdf)
library.add(faEnvelope)
library.add(faLink)
library.add(faClock)
library.add(faFileCirclePlus)
library.add(faTriangleExclamation)
library.add(faChevronDown)
library.add(faRotateLeft)
library.add(faRotateRight)
library.add(faFileDownload)

library.add(faInstagram)
library.add(faFacebook)
library.add(faFacebookF)
library.add(faTwitter)
library.add(faTiktok)

library.add(faWhatsapp)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.mixin({
  mounted: () => {
    if (window.location.pathname.indexOf('/refactor/') === 0) {
      history.replaceState('', '', '/' + window.location.pathname.replace(/\/refactor\//g, '') + window.location.search)
    }
  }
})

Sentry.init({
  Vue,
  dsn: 'https://7fa2d7abd29a9703594e3b4205ed8ea1@o1134224.ingest.us.sentry.io/4507102499897344',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['www.backroadclub.com', /^\//]
    })
  ],
  beforeSend: (event, hint) => {
    if (hint) {
      console.error(hint.originalException || hint.syntheticException)
    }
    return event
  },
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})

new Vue({
  router,
  store,
  vuetify: new Vuetify({}),
  render: h => h(App)
}).$mount('#app')
